import { useState, useCallback, useContext, useEffect } from "react";
import "./FindAStartup.css";
import { Button, TitlePage } from "../../atoms";
import { OptionTypes } from "../../types/types";
import { MultiValue } from "react-select";
import MultiSelectComponent from "components/atoms/Select/MultiSelectComponent";
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext";
import { LoginType } from "components/types/Context";
import { StartupsListReq } from "components/types/Api";
import clsx from "clsx";
import { MediaTablet } from "api/const/MediaQuery";
import useMediaQuery from "hook/useMediaQuery";
import { useDebounce } from "shared/hook/useDebounce";
import { useAuth } from "shared/auth";
import { isStringEmpty } from "shared/utils/utils";

export const FindAStartup = () => {
  const {
    loadingFilterOptions,
    getFilterOptionsList,
    filter,
    loginType,
    startupsList,
    reqStartup,
    setReqStartup,
    getStartupsList,
    tags,
    setTags,
    sectors,
    setSectors,
    constitutionStatus,
    setConstitutionStatus,
  } = useContext(AppGeneralContext);
  const { auth } = useAuth();
  const [startupNameValue, setStartupNameValue] = useState<string>("");
  const debouncedStartupName = useDebounce(startupNameValue, 500);
  const Disabled =
    (tags && tags.length !== 0) || (sectors && sectors.length !== 0) || (constitutionStatus && constitutionStatus.length !== 0) || (!!startupNameValue && !isStringEmpty(startupNameValue))
      ? false
      : true;

  useEffect(() => {
    let logged = auth?.jwtToken ? true : false;

    if (loginType !== LoginType.corporate) {
      return;
    }

    if (!logged) {
      return;
    }

    getFilterOptionsList(logged);
  }, [loginType, auth]);

  const filterOption = (par: MultiValue<OptionTypes> | undefined) => {
    let optionsValue: string[] = par?.map((x) => x.value) ?? [];
    return optionsValue;
  };

  useEffect(() => {
    if (!auth?.jwtToken || loginType !== LoginType.corporate) {
      return;
    }

    const storedOptions = localStorage.getItem("startupOptions");
    if (storedOptions) {
      const { constitutionStatuses, tags, sectors, name } = JSON.parse(storedOptions);
      getStartupsList(!!auth?.jwtToken, { constitutionStatuses, tags, sectors,searchText:name });
      return;
    }
    getStartupsList(!!auth?.jwtToken);
  }, [reqStartup, loginType, auth]);

  useEffect(() => {
    search();
  }, [constitutionStatus, tags, sectors, constitutionStatus, auth, debouncedStartupName]);

  const search = useCallback(() => {
      const trimmedValue = debouncedStartupName?.trim()
    let filterTags = filterOption(tags);
    let filterSectors = filterOption(sectors);
    let filterConstitutionStatus = filterOption(constitutionStatus);


    let req: StartupsListReq = {
      ...reqStartup,
      pageNum: 0,
      tags: filterTags,
      sectors: filterSectors,
      constitutionStatuses: filterConstitutionStatus,
      searchText:trimmedValue
    };
    localStorage.setItem("startupOptions", JSON.stringify({ constitutionStatuses: filterConstitutionStatus, tags: filterTags, sectors: filterSectors, name: trimmedValue }));
    setReqStartup(req);
  }, [constitutionStatus, sectors, tags, reqStartup, debouncedStartupName]);

  const reset = () => {
    setConstitutionStatus(undefined);
    setSectors(undefined);
    setTags(undefined);
    setStartupNameValue("");

    let req: StartupsListReq = {
      ...reqStartup,
      tags: [],
      sectors: [],
      constitutionStatuses: [],
      searchText:''
    };
    localStorage.setItem("startupOptions", JSON.stringify({ constitutionStatuses: [], tags: [], sectors: [], name: "" }));
    setReqStartup(req);
  };

  useEffect(() => {
    if (Disabled) reset();
  }, [Disabled]);

  return (
    <div className='row d-flex flex-row w-100 m-0 p-0 pb-5'>
      <div className='col-12 mt-5 p-0 m-0'>
        <TitlePage as='h3' className='font-weight-bold' title='Find Innovation Providers' />
      </div>

      <div className='col-12 mt-3 p-0 m-0'>
        <div className='row align-items-center'>
          <div className='col-xs-12 col-sm-12 col-md-4 pb-3'>
            <input
              name='startupName'
              type='text'
              className='form-input'
              maxLength={100}
              placeholder='Magic search...'
              value={startupNameValue}
              onChange={(x) => setStartupNameValue(x.target.value)}
            />
          </div>

          <div className={clsx("col-xs-12 col-sm-12 col-md-8 pb-3")}>
            <MultiSelectComponent
              heightControlSection='47px'
              isSearchable
              setOptionSelected={setTags}
              placeholder='Tags'
              className={"w-100"}
              options={filter.tags ? filter.tags : []}
              fieldName={"tags"}
              value={tags ? tags : null}
            />
          </div>
        </div>

        <div className='row align-items-center mb-3'>
          <div className='col-xs-12 col-sm-12 col-md-4 pb-3 pt-md-3'>
            <MultiSelectComponent
              isSearchable
              heightControlSection='100%'
              setOptionSelected={setSectors}
              placeholder='Industry'
              className={"w-100"}
              options={filter.sectors ? filter.sectors : []}
              fieldName={"sectors"}
              value={sectors ? sectors : null}
            />
          </div>

          <div className={clsx("col-xs-12 col-sm-12 col-md-4 pb-3 pt-md-3")}>
            <MultiSelectComponent
              isLoading={loadingFilterOptions}
              heightControlSection='47px'
              isSearchable
              setOptionSelected={setConstitutionStatus}
              placeholder='Status'
              className={"w-100"}
              options={filter.constitutionStatus ? filter.constitutionStatus : []}
              fieldName={"constitutionStatus"}
              value={constitutionStatus ? constitutionStatus : null}
            />
          </div>
          <div className='col-xs-12 col-sm-12 col-md-4 d-flex justify-content-between mt-3 mt-md-0'>
            <Button
              disabled={Disabled}
              onClick={() => {
                reset();
              }}
              className='ps-0 pe-0 w-100'
              color='var(--black)'
              background='var(--white)'
              borderColor='var(--black)'
              fontWeight={"800"}
              uppercase
              primary
              text='cancel'
              type='button'
            />
          </div>
        </div>
      </div>
    </div>
  );
};
